import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Plan extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="fondrt-plan">
                    <div className="fondrt-plan__wrapper">
                        <div className="fondrt-plan__title">Что планируется</div>

                        <div className="fondrt-plan__inner">
                            <div className="fondrt-plan__container">
                                <img
                                    className="fondrt-plan__image"
                                    src="/images/pic/fondrt/uslugi.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-plan__subtitle">
                                    Интеграция с Госуслугами
                                </div>
                                <div className="fondrt-plan__text">
                                    Наша команда подготовила проект к технической интеграции с
                                    единым порталом Госуслуг
                                </div>
                            </div>

                            <div className="fondrt-plan__container">
                                <img
                                    className="fondrt-plan__image"
                                    src="/images/pic/fondrt/design.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-plan__subtitle">Обновление дизайна</div>
                                <div className="fondrt-plan__text">
                                    Планируется редизайн Личного кабинета согласно новой
                                    дизайн-системе и UI-компонентов.
                                </div>
                            </div>

                            <div className="fondrt-plan__container">
                                <img
                                    className="fondrt-plan__image"
                                    src="/images/pic/fondrt/kabinet.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-plan__subtitle">
                                    Настройка Личного кабинета
                                </div>
                                <div className="fondrt-plan__text">
                                    Следующая задача команды развитие функционала Личного кабинета.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Plan;
